import React from 'react'

export default function UberEatsHelp({data}) {
  return (
    <>
      <section className="uber-eats-help-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <h2 className="heading center-heading">{data?.headingPart1} <span className="gradiant-color">{data?.headingPart2}</span> {data?.headingPart3}</h2>
            </div>

            <div className="col-lg-9 text-center">
              {data?.desc?.map((item, index)=>(
                <p key={index}>{item}</p>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
